<template>
  <div id="Navbar">
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <div class="border-right border-dark" id="sidebar-wrapper">
        <b-row>
          <b-col md="1"></b-col>
          <b-col md="10">
            <img src="../../assets/SSBG.png" width="100px" style="padding: 10px" alt="LIF Logo" />
          </b-col>
          <b-col md="1"></b-col>
        </b-row>

        <div class="list-group list-group-flush">
          <router-link class="text-light p-3" :to="{ name: 'Home' }" exact>
            <span class="text-active">INICIO</span>
          </router-link>
          <router-link class="text-light p-3" :to="{ name: 'Users' }">
            <span class="text-active">USUARIOS</span>
          </router-link>
          <router-link class="text-light p-3" :to="{ name: 'Invest' }">
            <span class="text-active">COLOCACIONES</span>
          </router-link>
          <router-link class="text-light p-3" :to="{ name: 'InvestPublic' }">
            <span class="text-active">COLOCACIONES PÚBLICAS</span>
          </router-link>
          <router-link class="text-light p-3" :to="{ name: 'PaymentReports' }" exact>
            <span class="text-active">DEPÓSITOS</span>
          </router-link>
          <router-link class="text-light p-3" :to="{ name: 'WithdrawReports' }" exact>
            <span class="text-active">SOLICITUDES DE RETIRO</span>
          </router-link>
          <router-link class="text-light p-3" :to="{ name: 'EarningLost' }" exact>
            <span class="text-active">GANANCIAS Y PÉRDIDAS</span>
          </router-link>
        </div>
      </div>
      <!-- /#sidebar-wrapper -->

      <!-- Page Content -->
      <div id="page-content-wrapper">
        <b-navbar toggleable="lg" type="light" style="
            box-shadow: 0px 0.3px 0.3px rgba(0, 0, 0, 0.4);
            background: linear-gradient(to right, #CF173C, #8A0F3D);"
          :class="{ 'd-none': $route.path === '/admin/login' }">
          <b-navbar-brand href="#" @click="toggleNav">
            <b-icon-list></b-icon-list>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse" />

          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-item-dropdown right>
                <!-- Using 'button-content' slot -->
                <template v-slot:button-content>
                  <em class="text-light">
                    <v-icon v-if="readed" name="bell" scale="1.2" color="#CF173C"></v-icon>
                    <v-icon v-if="!readed" name="bell" scale="1.2"></v-icon>
                  </em>
                </template>
                <div class="scroll">
                  <div v-show="progress" class="text-center text-primary mt-3">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Cargando...</strong>
                  </div>
                  <div v-show="!progress">
                    <div class="text-right">
                      <a class="primary mr-2" v-if="notifications.length != 0" @click="allRead()"
                        style="cursor: pointer">Marcar como leidas</a>

                    </div>
                    <div v-for="notif of notifications" :key="notif.id"
                      @click="OpenInfo(notif.notification_id, notif.notification.room.user_id, notif.notification.room.id)">
                      <b-dropdown-item v-if="readed" style="width: 300px">
                        <b-row align-v="center" class="py-0 my-0">
                          <div class="text-center" align-self="center" style="display: inline-block; width: 20%">
                            <img v-if="notif.notification.profile_picture" :src="notif.notification.profile_picture"
                              height="30px" class="text-center rounded-circle" style="max-width: 30px;" alt="" />
                            <img v-else src="../../assets/LogoSSBG.png" height="30px" class="text-center rounded-circle"
                              style="max-width: 30px;" alt="" />
                          </div>

                          <div style="display: inline-block; width: 80%">
                            <strong class="py-0 my-0">{{
                              notif.notification.title
                            }}</strong>
                            <p class="py-0 my-0">Te ha enviado un mensaje</p>
                          </div>
                        </b-row>

                      </b-dropdown-item>

                      <hr class="py-0 my-1" />
                    </div>
                    <b-dropdown-item v-if="!readed">
                      <v-icon name="check"></v-icon> Estás al día
                    </b-dropdown-item>
                  </div>
                </div>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-item-dropdown right>
                <!-- Using 'button-content' slot -->
                <template v-slot:button-content>
                  <em class="text-light">
                    <img :src="picture" class="mr-2 rounded-circle" width="40 px" height="40 px" alt />
                    <span v-if="name">{{ name }}</span>
                    <!-- Luis E. Hernandez -->
                  </em>
                </template>

                <b-dropdown-item @click="logoutMenu">Cerrar sesión</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>

        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { mapActions, mapState } from "vuex";
export default {
  name: "Navbar",
  data() {
    return {
      name: Cookies.get("user_name"),
      picture: Cookies.get("picture"),
      notifications: [],
      progress: false,
      readed: false,
    };
  },
  computed: {
    ...mapState({}),
  },
  mounted: function () {
    $("#menu-toggle").click(function (e) {
      console.log("click");
      e.preventDefault();
      $("#wrapper").toggleClass("toggled");
    });
    this.Notifications();
  },
  methods: {
    ...mapActions(["logout", "getAllNotifications", "changeAllNotif", "changeStatusNotif"]),
    toggleNav() {
      $("#wrapper").toggleClass("toggled");
    },
    OpenInfo(id, user, room) {
      let form = {
        id: id,
        status: 1
      }
      this.changeStatusNotif(form)
        .then((response) => {
          if (response.code == 200) {
            this.Notifications()
            console.log(response)
          }
        })
      this.$store.commit('CHATROOM', room)
      this.$router.push('/admin/users/' + user)
    },
    allRead() {
      let form = {
        status: 1
      }
      this.changeAllNotif(form).then((response) => {
        if (response.code == 200) {
          this.readed = false
          this.notifications = []
        }
      });
    },
    Notifications() {
      this.progress = true;
      let form = {
        id: Cookies.get('id')
      }
      this.getAllNotifications(form).then((response) => {
        if (response.code == 200) {
          this.progress = false;
          this.notifications = response.data;
          if (this.notifications.length != 0) {
            this.readed = true
          } else {
            this.readed = false
          }
        }
      });
    },
    logoutMenu() {
      Swal.fire({
        title: "¿Desea cerrar la sesión?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        confirmButtonText: "Cerrar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.logout().then((data) => {
            console.log(data);
            this.$router.push("/admin/login");
          });
        }
      });
    },
  },
};
</script>
<style>
.scroll {
  overflow: auto;
  overflow-x: hidden;

  max-height: 300px;
}


.app-main {
  flex: 1;
  display: flex;
  z-index: 8;
  position: relative;
}

.app-main .app-main__outer {
  z-index: 9;
  padding-left: 280px;
}

.app-main__outer {
  padding-left: 80px;
}

.app-main .app-main__outer {
  flex: 1;
  flex-direction: column;
  display: flex;
  z-index: 12;
}

.app-main.app-main__outer {
  padding-bottom: 60px;
}

.app-main__outer {
  padding-left: 0 !important;
}

.app-main__inner {
  padding: 15px 15px 0;
}

.app-main .app-main__inner {
  padding: 30px 30px 0;
  flex: 1;
}

.app-page-title .page-title-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.app-page-title .page-title-heading,
.app-page-title .page-title-subheading {
  margin: 0;
  padding: 0;
}

.app-page-title .page-title-heading {
  font-size: 1.25rem;
  font-weight: 400;
  display: flex;
  align-content: center;
  align-items: center;
}

.app-page-title .page-title-subheading {
  padding: 3px 0 0;
  font-size: 0.88rem;
  opacity: 0.6;
}

.app-page-title .page-title-subheading .breadcrumb {
  padding: 0;
  margin: 3px 0 0;
  background: black;
}

.app-page-title .page-title-actions {
  margin-left: auto;
}

.app-page-title .page-title-actions .breadcrumb {
  margin: 0;
  padding: 0;
  background: black;
}

.menu-item {
  color: white;
}

.menu-item:hover {
  background-color: #cfcfcf;
  background: #c7c7c7;
}

#wrapper {
  overflow-x: hidden;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.router-link-active .text-active {
  color: #CF173C;
}

.router-link-active {
  /* background-color: #606b75;*/
  background-color: none !important;
}

#sidebar-wrapper {
  position: relative;
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
  color: white;
  background-image: url('../../assets/Sidebar.png');
  background-image: url('../../assets/Sidebar2.png');
  z-index: 2;
}

#sidebar-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
}


#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
  color: white;
}

#sidebar-wrapper .list-group {
  text-align: left;
  width: 15rem;
  padding: 20px;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
</style>
